import React, { useEffect, useState } from 'react'
import { Box, Button, FormControl, TextField, Typography } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { useAppSelector, useAppDispatch } from '../../app/hooks'
import { useNavigate } from "react-router-dom"
import { selectIsAuth, signInAsync, signInWithEmailAndPasswordAsync } from './AuthSlice'
import googleIcon from "./icons8-google.svg";
import microsoftIcon from "./icons8-microsoft.svg";

export type ProtectedRedirectState = {
  from: Location
}

function Login() {
  const isAuth = useAppSelector(selectIsAuth)
  const location = useLocation()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const redirectTo = (location && location.state) ? (location.state as ProtectedRedirectState).from.pathname : '/home'
  useEffect(() => {
    if (isAuth) {
      navigate({ 'pathname': redirectTo, 'search': (location.state as any)?.from?.search, })
    }
  }, [isAuth, redirectTo, navigate, location.state])
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignContent: 'center', flexDirection: 'column' }}>
      <Typography variant="h4" sx={{ marginBottom: 5, }}>Login to proceed</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignContent: 'center', flexDirection: 'column', mt: 2, borderTop: 2, borderColor: '#ddd', pt: 8 }}>
        <Typography variant="caption" color="text.secondary" sx={{ marginBottom: 5, alignSelf: 'center' }}>Please sign in using your <i>Microsoft</i> or <i>Google</i> account. No prior registration with RentFinder.ai is required.</Typography>

        <Button sx={{ marginBottom: 5, width: '300px', alignSelf: 'center' }}
          startIcon={<img src={googleIcon}></img>}
          size='large' variant='outlined' onClick={() => { dispatch(signInAsync({ redirectTo, providerId: 'Google' })) }}>
          Google
        </Button>
        <Button sx={{ marginBottom: 5, width: '300px', alignSelf: 'center' }}
          startIcon={<img src={microsoftIcon}></img>}
          size='large' variant='outlined' onClick={() => { dispatch(signInAsync({ redirectTo, providerId: 'Microsoft' })) }}>
          Microsoft
        </Button>

        <Typography variant="caption" color="text.secondary" sx={{ marginBottom: 5, alignSelf: 'center' }}>Or you can use your email.</Typography>
        <Box sx={{ width: '100%', textAlign: 'center' }}>
          <Button variant="outlined" sx={{ marginBottom: 5, marginRight: 1, width: '145px', alignSelf: 'center' }} onClick={() => {
            navigate('/loginWithEmail/register')
          }}>Register</Button>
          <Button variant="outlined" sx={{ marginBottom: 5, width: '145px', alignSelf: 'center' }} onClick={() => {
            navigate('/loginWithEmail/login')
          }}>Login</Button>
        </Box>
      </Box>
    </Box>
  )
}

export default Login